import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteAtm = ({ atmId }: { atmId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Atm/DeleteAtm/${atmId}`);
};

type QueryFnType = typeof deleteAtm;

type UseDeleteAtmOptions = {
  atmId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteAtm = ({ config }: UseDeleteAtmOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή του ΑΤΜ.`, 500);
      console.error("Couldnt delete Atm", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllAtms"]);
      addNotification(`Το ΑΤΜ Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteAtm,
  });
};
